import { Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./pages/home/HomeComponent";
import "./css/bootstrap/bootstrap.css";
import ProtectedRoute from "./ProtectedRoute";
import HelpComponent from "./pages/HelpComponent";
import FAQComponent from "./pages/FAQComponent";
import SafetyComponent from "./pages/SafetyComponent";
import PrivacyComponent from "./pages/PrivacyComponent";
import ContactUsComponent from "./pages/ContactUsComponent";
import BehaviorComponent from "./pages/BehaviourComponent";
import CSAEComponent from "./pages/CSAEComponent";
import CookiesComponent from "./pages/CookiesComponent";
import TermsAndConditionsComponent from "./pages/TermsAndConditionsComponent";
import LoginComponent from "./pages/LoginComponent";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "@mui/material";
import { theme } from "./pages/Theme/theme";
import TCMs from "./pages/dynamic/TermsAndConditonsMobile";
import Dashboard from "./pages/dashboard/Dashboard";
import LanguagePolicyComponent from "./pages/LanguagePolicyComponent";
import CommunityGuidelinesComponent from "./pages/CommunityGuidelinesComponent";
import UserProfileComponent from "./pages/UserProfileComponent";
import YourDataComponent from "./pages/YourDataComponent";
import NotFoundComponent from "./pages/NotFoundComponent";
import MarriageRewardTermsComponent from "./pages/MarriageRewardTermsComponent";
import { REWARD_TERMS_PATH } from "./pages/home/data/reward";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <div
          className="App"
          style={{ overflowX: "clip", minHeight: "100vh", background: "white" }}
        >
          {/* Public pages render their own header and footer through SiteLayout. */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<HomePage />} />
            <Route path="/u/:username" element={<UserProfileComponent />} />
            <Route path="/help" element={<HelpComponent />} />
            {/* Gold membership was retired when MJMarry became free. */}
            <Route path="/gold" element={<Navigate to="/" replace />} />
            <Route path="/faq" element={<FAQComponent />} />
            <Route path="/safety" element={<SafetyComponent />} />
            <Route path="/privacy" element={<PrivacyComponent />} />
            <Route path="/your-data" element={<YourDataComponent />} />
            <Route path="/languagepolicy" element={<LanguagePolicyComponent />} />
            <Route path="/communityguidelines" element={<CommunityGuidelinesComponent />} />
            <Route path="/contactus" element={<ContactUsComponent />} />
            <Route path="/behaviour" element={<BehaviorComponent />} />
            <Route path="/cookies" element={<CookiesComponent />} />
            <Route path="/csae" element={<CSAEComponent />} />
            <Route path={REWARD_TERMS_PATH} element={<MarriageRewardTermsComponent />} />
            <Route
              path="/termsandconditions"
              element={<TermsAndConditionsComponent />}
            />
            <Route
              path="/termsandconditionsmobile"
              element={<TCMs />}
            />
            <Route path="/login" element={<LoginComponent />} />
            <Route path="/dashboard" element={<ProtectedRoute />}>
              <Route index element={<Dashboard />} />
              <Route path=":section" element={<Dashboard />} />
              {/* Old deep link from before sections had their own URLs. */}
              <Route path="user/disableacc" element={<Navigate to="/dashboard" replace />} />
            </Route>
            <Route path="*" element={<NotFoundComponent />} />
          </Routes>
        </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
